__turbopack_context__.v({
  "bookCta": "YBUagW_bookCta",
  "dMd": "YBUagW_dMd",
  "description": "YBUagW_description",
  "phoneImageContainer": "YBUagW_phoneImageContainer",
  "progressLine": "YBUagW_progressLine",
  "progressShortLine": "YBUagW_progressShortLine",
  "root": "YBUagW_root",
  "sectionContent": "YBUagW_sectionContent",
  "sequenceAnimation": "YBUagW_sequenceAnimation",
  "step1Img": "YBUagW_step1Img",
  "stepContainer": "YBUagW_stepContainer",
  "stepContainerExpanded": "YBUagW_stepContainerExpanded",
  "stepContainerWrapper": "YBUagW_stepContainerWrapper",
  "stepCount": "YBUagW_stepCount",
  "stickyWrapper": "YBUagW_stickyWrapper",
  "tabsContainer": "YBUagW_tabsContainer",
  "textContainer": "YBUagW_textContainer",
});
